import React, { useEffect, useMemo, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useGetTenantQuery, useGetUserProfileQuery } from "../../redux/api/BaseApi";
import { useReduxDispatch, useReduxSelector } from "../../redux/hooks";
import { REVELATION_IFRAME } from "../../Variables/StaticVariables";
import { updateIframeSrc, setIframeLoaded, mimicUser, setFirstIframeRequest } from "../../slices/RevelationSlice";
import { RightBar } from "../RightBar/RightBar";
import { FavoriteApi } from "../../redux/api/FavoriteApi";
import { PartialSpinny, Spinny } from "../Nav/Spinny";
import { UserApi } from "../../redux/api/UserApi";
import { trimChar } from "../../utils/utils";
import { createUserManager } from "redux-oidc";
import { oAuthSettings } from "../Auth/AuthSettings";
import SessionKeepAlive from "./SessionKeepAlive";

//const ChatRequestModule = React.lazy(() => import("chat/ChatRequest"));

const RevelationIframe = (props: { url?: string }) => {

  const navigate = useNavigate();
  const dispatch = useReduxDispatch()
  const mimicUid = useReduxSelector((state) => state.revI.mimicUid)
  const { data, error } = useGetUserProfileQuery(mimicUid)
  const { data: tenant } = useGetTenantQuery()
  const [invalidateProfile] = UserApi.useInvalidateProfileMutation()
  //const [iframeLoaded, setIFrameLoaded] = useState(false)

  // Redux Selectors
  const revI = useReduxSelector((state) => state.revI);
  const user = useReduxSelector((state) => state.auth.user);
  const iframeRef = React.useRef<HTMLIFrameElement>()
  //Only update the IFrame landing page if the mimic user id changes, NOT when the access token is updated by a silent renew.
  const hasAccessToken = !user?.access_token;
  const homeLandingPage = useMemo(() => {
    //console.log('hasAccessToken', hasAccessToken)
    return `/OAuth/SignInWithJwt?redirectToHomepage=true&jwt=${user?.access_token}&n=${revI.uniqueId}&mimicUid=${mimicUid}${revI.currentIframeSrc ? `&redirectUrl=${encodeURIComponent(revI.currentIframeSrc)}` : ''}`
  }, [revI.uniqueId, mimicUid, hasAccessToken, revI.currentIframeSrc]);

  const isFirstIframeRequest = useMemo(() => revI.isFirstIframeRequest, [revI.currentIframeSrc]);

  ///The Url passed in from the Router
  useEffect(() => {
    if (props?.url)
      dispatch(updateIframeSrc(props.url))
  }, [props.url])

  // Constants
  const iframeClass = "grow";
  useEffect(() => {
    //Add event listener for Events that get posted as messages in the IFrame so we can trigger things like updating the banner
    const messageListener = (e) => {
      try {
        if (e.data?.indexOf && e.data?.indexOf('{') === 0) {
          console.log('JSON Message Recieved', e.data);
          const messageObj = JSON.parse(e.data);
          if ('message' in messageObj && messageObj.message === 'mimic') {
            dispatch(mimicUser(messageObj.uid))
            //Go to homepage
            dispatch(updateIframeSrc(null));
          } else if ('message' in messageObj && messageObj.message === 'log_a_ticket') {
            navigate(`/ticket/new/details?parentCallId=${messageObj?.parentCallId || ""}&splitActionIds=${messageObj?.splitActionIds || ""}&splitTicketId=${messageObj?.splitTicketId || ""}`)
          } else if ('message' in messageObj && messageObj.message === 'goH') {
            navigate(`/ticket/${messageObj.ticketId}/?From=home`);
          }
        }
      } catch (err) {
        console.error('ouch in window.addEventListener', err);
      }

      if (e.data === "RefreshNav") {
        //Re-freth the user's profile 
        console.log('RefreshNa - v Re-freth the users profile');
        invalidateProfile();
      };

      //The webforms app will post this message when the user's session has expired
      if (e.data === 'SessionExpired') {
        console.log('SessionExpired')
        let userManager = createUserManager(oAuthSettings)
        userManager.signoutRedirect({
          extraQueryParams: { logoutMessage: 'Session has expired.' },
        });
      }

      if (e.data === 'RefreshFav') {
        //reload favorites (not cached)
        console.log('invalidateFavorites');
        dispatch(FavoriteApi.util.invalidateTags(['GetUserFavs']))
      }
    };

    var ev = window.addEventListener("message", messageListener, false)
    return () => { window.removeEventListener("message", messageListener) }
  }, []);
  if (!user?.access_token || !data || !tenant) return (<></>);
  //console.log(encodeURIComponent(revI.currentIframeSrc));
  // Error Handling

  const iFrameLoaded = (e) => {
    //Throws cross-origin error if we try to access the contentWindow of the iframe
    //console.log('iFrameLoaded', e.target?.contentWindow?.goH);
    dispatch(setIframeLoaded(true));
    dispatch(setFirstIframeRequest(false));
    //setIFrameLoaded(true);
  }


  if (error) {
    return <div>iframe failed to load because of a query error</div>;
  }


  if (isFirstIframeRequest || revI.currentIframeSrc === null || revI.currentIframeSrc?.length === 0) {
    return (
      <>
        <RightBar>
          {revI.iFrameLoading && <Spinny />}
          <iframe ref={iframeRef}
            onLoad={iFrameLoaded}
            className={iframeClass}
            name={REVELATION_IFRAME}
            title={REVELATION_IFRAME}
            src={`${tenant?.Tenant_Url}${homeLandingPage}`}
          />
          <Outlet />
        </RightBar>
        <SessionKeepAlive />
      </>
    );
  }

  var src = (revI.currentIframeSrc?.toLowerCase().startsWith('http://') || revI.currentIframeSrc?.toLowerCase().startsWith('https://'))
    ? revI.currentIframeSrc
    : `${trimChar(tenant?.Tenant_Url, '/')}${revI.currentIframeSrc}`;


  return (
    <>
      <RightBar>
        {revI.iFrameLoading && <PartialSpinny z={98} />}
        <iframe ref={iframeRef}
          className={iframeClass}
          name={REVELATION_IFRAME}
          title={REVELATION_IFRAME}
          onLoad={iFrameLoaded}
          src={src}
        />
        <Outlet />
      </RightBar>
      <SessionKeepAlive />
    </>
  );
};
export default RevelationIframe;
